import { Link } from 'react-router-dom'
import PageHero from '../components/PageHero'
import PageCardImage from '../components/PageCardImage'
import { SOLUTIONS } from '../content/solutionsContent'
import { IMAGES } from '../content/images'

export default function ResourcesPage() {
  return (
    <div className="page">
      <PageHero
        eyebrow="Resources"
        title="Program Information & Specialty Solutions"
        lead="Explore targeted pest management programs, facility-focused services, and specialty solutions designed for regulated commercial and industrial environments."
        image={IMAGES.resources}
        imageAlt="Program resources and documentation"
      />

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="page-grid page-grid--2">
            <div className="page-card">
              <h2 className="page-card__title">Specialty Solution Pages</h2>
              <p className="page-card__text">
                Detailed program overviews for targeted pest pressures and facility-specific needs.
              </p>
              <div className="page-mini-gallery">
                {SOLUTIONS.slice(0, 4).map((solution) => (
                  <Link
                    key={solution.slug}
                    to={`/solutions/${solution.slug}`}
                    className="page-mini-gallery__item"
                  >
                    <img src={solution.image} alt={solution.title} loading="lazy" />
                  </Link>
                ))}
              </div>
              <ul className="page-list page-list--links">
                {SOLUTIONS.map((solution) => (
                  <li key={solution.slug}>
                    <Link to={`/solutions/${solution.slug}`}>{solution.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="page-card page-card--media">
              <PageCardImage src={IMAGES.grainHandling} alt="Grain handling operations" />
              <h2 className="page-card__title">Company Information</h2>
              <p className="page-card__text">
                Learn more about our mission, facility expertise, and commitment to protecting what matters most.
              </p>
              <ul className="page-list page-list--links">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services Overview</Link></li>
                <li><Link to="/industries">Industries We Serve</Link></li>
                <li><Link to="/contact">Request Information</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
